<template>
  <tbody>
    <tr data-test="realintention-realintention">
      <td
        data-test="content"
        class="boss-table-data text-left pega-white-space-normal"
      >
        {{ content }}
      </td>
      <td
        data-test="createDate"
        class="boss-table-data text-center"
      >
        {{ realIntention.createDate | formatDate }}
      </td>
      <td
        data-test="updateDate"
        class="boss-table-data text-center"
      >
        {{ realIntention.updateDate | formatDate }}
      </td>
      <td class="boss-table-data">
        <button
          class="boss-icon-pencil"
          data-test="edit"
          @click="$router.push({ name: 'realIntentionEdit', params: { realIntentionId: realIntention.id }})"
        />
      </td>
      <td class="boss-table-data">
        <button
          class="boss-icon-trash"
          data-test="remove"
          @click="doRemove(realIntention.id)"
        />
      </td>
      <td class="boss-table-data">
        <button
          class="boss-button"
          type="button"
          data-test="pc-preview-button"
          @click="windowOpenPcPreview"
        >
          PC版
        </button>
        <button
          class="boss-button"
          type="button"
          data-test="sp-preview-button"
          @click="windowOpenSpPreview"
        >
          スマホ版
        </button>
      </td>
      <td class="boss-table-data">
        <div class="switch toggle-switch">
          <input
            :id="`toggle-${realIntention.id}`"
            data-test="toggle"
            class="toggle-input"
            type="checkbox"
            :checked="realIntention.isPublished"
            @change="changeDisplayStatus(realIntention.id, realIntention.isPublished)"
          >
          <label
            :for="`toggle-${realIntention.id}`"
            class="toggle-label"
          />
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return val ? dayjs(val).format('YYYY/MM/DD') : ''
    }
  },
  props: {
    realIntention: {
      type: Object,
      required: true
    }
  },
  computed: {
    content () {
      return [
        this.realIntention.post,
        this.realIntention.gender.name,
        this.realIntention.age ? `${this.realIntention.age}歳` : '',
        this.realIntention.serviceYear ? `入社${this.realIntention.serviceYear}年` : '',
        this.realIntention.career.name
      ].filter(v => v).join('/')
    }
  },
  methods: {
    doRemove (realIntentionId) {
      this.$dialog.confirm('削除しますか？')
        .then(() => {
          this.$http.secured.delete(`/real_intention/real_intentions/${realIntentionId}`)
            .then(() => {
              this.$toasted.global.success({ message: '社員からの評判を削除しました' })
              this.$emit('updated')
            })
        })
        .catch(() => {})
    },
    changeDisplayStatus (id, isPublished) {
      this.$http.secured.put(`/real_intention/real_intentions/${id}/public`, {
        isPublished: !isPublished
      }).then((response) => {
        this.$toasted.global.success({ message: '公開区分を更新しました。' })
        this.$emit('update-display', response.data)
      })
    },
    windowOpenPcPreview () {
      const routeData = this.$router.resolve({ name: 'realIntentionPreviewPc', params: { id: this.realIntention.id } })
      window.open(routeData.href, '_blank', 'height=660, width=995, left=80, top=50, scrollbars=yes, menubar=yes, resizable=yes')
    },
    windowOpenSpPreview () {
      const routeData = this.$router.resolve({ name: 'realIntentionPreviewSp', params: { id: this.realIntention.id } })
      window.open(routeData.href, '_blank', 'height=667, width=394, left=80, top=50, scrollbars=yes, menubar=yes, resizable=yes')
    }
  }
}
</script>
